import { render, staticRenderFns } from "./region.vue?vue&type=template&id=1f782379&"
import script from "./region.vue?vue&type=script&lang=js&"
export * from "./region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f782379')) {
      api.createRecord('1f782379', component.options)
    } else {
      api.reload('1f782379', component.options)
    }
    module.hot.accept("./region.vue?vue&type=template&id=1f782379&", function () {
      api.rerender('1f782379', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/region-manage/region.vue"
export default component.exports